// One icon per game concept (GDD 08 §4): shapes differ, so colour is never the only cue.
import { Coins, Flame, type LucideIcon, Pickaxe, Sparkles, Wheat } from 'lucide-react';

export type ResourceKey = 'metal' | 'gas' | 'supplies' | 'credits' | 'influence';

export const RESOURCE_ICONS: Record<ResourceKey, LucideIcon> = {
  metal: Pickaxe,
  gas: Flame,
  supplies: Wheat,
  credits: Coins,
  influence: Sparkles,
};

export const RESOURCE_TEXT: Record<ResourceKey, string> = {
  metal: 'text-metal',
  gas: 'text-gas',
  supplies: 'text-supplies',
  credits: 'text-credits',
  influence: 'text-influence',
};

export const RESOURCE_NAMES: Record<ResourceKey, string> = {
  metal: 'Metal',
  gas: 'Gas',
  supplies: 'Supplies',
  credits: 'Credits',
  influence: 'Influence',
};
